import type { editions as en } from '@/i18n/locales/en/editions';
import type { Translation } from '@/i18n/types';

export const editions: Translation<typeof en> = {
  fit: {
    sections: {
      home: 'Início',
      insights: 'Perspetivas',
      programs: 'Programas',
      content: 'Conteúdo',
    },
    items: {
      overview: 'Visão geral',
      departments: 'Departamentos',
      users: 'Utilizadores',
      vitality: 'Vitalidade',
      participation: 'Participação',
      pilots: 'Pilotos',
      challenges: 'Desafios',
      communications: 'Comunicação',
      documents: 'Documentos',
      reports: 'Relatórios',
      settings: 'Configurações',
    },
  },
  soccer: {
    sections: {
      home: 'Início',
      insights: 'Perspetivas',
      programs: 'Programas',
    },
    items: {
      overview: 'Visão geral',
      departments: 'Equipas',
      users: 'Jogadores',
      vitality: 'Vitalidade',
      participation: 'Participação',
      pilots: 'Pilotos',
      challenges: 'Desafios',
    },
  },
};
